// Keep all visited agent panels mounted with display:none so streams survive
// agent-to-agent navigation — matches dev's ChatPanels pattern.
// MAX_MOUNTED caps memory use with LRU eviction of oldest visited agent.

import { useRef } from 'react';
import { ChatRuntimeProvider } from '@/app/providers/ChatRuntimeProvider';
import { cn } from '@/shared/lib/cn';

interface ChatPanelsProps {
  selectedAgentId: string | null;
  resetGeneration: number;
}

const MAX_MOUNTED = 5;

export default function ChatPanels({ selectedAgentId, resetGeneration }: ChatPanelsProps) {
  // Ordered list: oldest first for LRU eviction.
  const visitedRef = useRef<string[]>([]);
  const lastResetGenerationRef = useRef(resetGeneration);

  if (lastResetGenerationRef.current !== resetGeneration) {
    visitedRef.current = [];
    lastResetGenerationRef.current = resetGeneration;
  }

  if (selectedAgentId) {
    const list = visitedRef.current;
    if (!list.includes(selectedAgentId)) {
      if (list.length >= MAX_MOUNTED) list.shift();
      list.push(selectedAgentId);
    }
  }

  if (visitedRef.current.length === 0) return null;

  return (
    <>
      {visitedRef.current.map((agentId) => (
        <div
          key={agentId}
          className={cn(
            'min-h-0 flex-1 flex-col overflow-hidden',
            agentId === selectedAgentId ? 'flex' : 'hidden',
          )}
        >
          <ChatRuntimeProvider agentId={agentId} layout="embedded" hideThreadSidebar />
        </div>
      ))}
    </>
  );
}
